import { render } from "./projectBasicsInfo.vue?vue&type=template&id=ff87f594&scoped=true"
import script from "./projectBasicsInfo.vue?vue&type=script&lang=js"
export * from "./projectBasicsInfo.vue?vue&type=script&lang=js"

import "./projectBasicsInfo.vue?vue&type=style&index=0&id=ff87f594&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff87f594"]])

export default __exports__